<div class="landing-wrapper">
    <a class="bg-app outline-primary foreground"
        (click)="openUserInfoModel('orderType')">
        <figure>
            <img src="assets/images/take-out.png" alt="">
        </figure>{{ 'Take_Out' | translate }}</a>
    <br>
    <br>
    <br>
    <br>

    <h1>{{ 'H1_Text' | translate }}</h1>
    <h2>{{ 'H2_Text' | translate }}</h2>
    <h3>{{ 'H3_Text' | translate }}</h3>
    <h4>{{ 'H4_Text' | translate }}</h4>
    <h5>{{ 'H5_Text' | translate }}</h5>

    <p>{{ 'Paragraph_Style' | translate }}
        {{ 'Lorem_Text' | translate }}
    </p>
    <br>
    <br>
    <div>{{ 'Normal_Style' | translate }}
        {{ 'Lorem_Text' | translate }}
    </div>

    <br>
    <br>
    <br>
    <br>

    <div class="demo">
    <h1>{{ 'Buttons' | translate }}</h1>
    <br>
    <h2>{{ 'Basic_Buttons' | translate }}</h2>
    <div class="button-row">
        <button mat-button>{{ 'Basic' | translate }}</button>
        <button mat-button color="primary">{{ 'Primary' | translate }}</button>
        <button mat-button color="accent">{{ 'Accent' | translate }}</button>
        <button mat-button color="warn">{{ 'Warn' | translate }}</button>
        <button mat-button disabled>{{ 'Disabled' | translate }}</button>
        <a mat-button routerLink=".">{{ 'Link' | translate }}</a>
    </div>
    <br>
    <h2>{{ 'Raised_Buttons' | translate }}</h2>
    <div class="button-row">
        <button mat-raised-button>{{ 'Basic' | translate }}</button>
        <button mat-raised-button color="primary">{{ 'Primary' | translate }}</button>
        <button mat-raised-button color="accent">{{ 'Accent' | translate }}</button>
        <button mat-raised-button color="warn">{{ 'Warn' | translate }}</button>
        <button mat-raised-button disabled>{{ 'Disabled' | translate }}</button>
        <a mat-raised-button routerLink=".">{{ 'Link' | translate }}</a>
    </div>
    <br>
    <h2>{{ 'Flat_Buttons' | translate }}</h2>
    <div class="button-row">
        <button mat-flat-button>{{ 'Basic' | translate }}</button>
        <button mat-flat-button color="primary">{{ 'Primary' | translate }}</button>
        <button mat-flat-button color="accent">{{ 'Accent' | translate }}</button>
        <button mat-flat-button color="warn">{{ 'Warn' | translate }}</button>
        <button mat-flat-button disabled>{{ 'Disabled' | translate }}</button>
        <a mat-flat-button routerLink=".">{{ 'Link' | translate }}</a>
    </div>

    <br>
    <h2>{{ 'Icon_Buttons' | translate }}</h2>
    
    <div class="button-row">
        <button mat-icon-button>
        <mat-icon>Favorite</mat-icon>
    </button>
    <button mat-icon-button disabled color="primary">
        <mat-icon>
            <mat-spinner color="primary" diameter="20"></mat-spinner>
        </mat-icon>
    </button>
    <button mat-icon-button disabled color="accent">
        <mat-icon>
            <mat-spinner color="accent" diameter="20"></mat-spinner>
        </mat-icon>
    </button>
        <button mat-icon-button color="accent">
        <mat-icon>Favorite</mat-icon>
    </button>
        <button mat-icon-button color="warn">
        <mat-icon>Favorite</mat-icon>
    </button>
        <button mat-icon-button disabled>
        <mat-icon>Favorite</mat-icon>
    </button>
    </div>

    <br>
    <h2>{{ 'Basic_Buttons' | translate }}</h2>
    <div class="button-row">
        <button mat-button>{{ 'Basic' | translate }}</button>
        <button mat-button color="primary">{{ 'Primary' | translate }}<mat-icon><mat-spinner color="accent" diameter="20">
            </mat-spinner></mat-icon>
        </button>
        <button mat-button color="accent">{{ 'Accent' | translate }}</button>
        <button mat-button color="warn">{{ 'Warn' | translate }}</button>
        <button mat-button disabled>
            <mat-icon><mat-spinner diameter="20">
            </mat-spinner></mat-icon>{{ 'Disabled' | translate }}</button>
        <a mat-button routerLink=".">{{ 'Link' | translate }}</a>
    </div>

    <h2>{{ 'Raised_Buttons' | translate }}</h2>
    <div class="button-row">
        <button mat-raised-button disabled>{{ 'Basic' | translate }}<mat-icon><mat-spinner diameter="20">
        </mat-spinner></mat-icon>
    </button>
        <button mat-raised-button color="primary">{{ 'Primary' | translate }}<mat-icon><mat-spinner color="accent" diameter="20">
        </mat-spinner></mat-icon>
    </button>
        <button mat-raised-button color="accent">{{ 'Accent' | translate }}<mat-icon><mat-spinner color="primary" diameter="20">
        </mat-spinner></mat-icon>
    </button>
        <button mat-raised-button color="warn">{{ 'Warn' | translate }}<mat-icon><mat-spinner color="accent" diameter="20">
        </mat-spinner></mat-icon>
    </button>
        <button mat-raised-button disabled>{{ 'Disabled' | translate }}<mat-icon><mat-spinner color="warn" diameter="20">
        </mat-spinner></mat-icon>
    </button>
        <a mat-raised-button routerLink=".">
        <mat-icon><mat-spinner diameter="20">
        </mat-spinner></mat-icon>{{ 'Link' | translate }}</a>
    </div>
    <br><br><br><br><br><br><br><br><br>
    </div>
</div>
